import { useState, useEffect } from 'react'

// Track current card state so we don't call unnecessary renders
let cardsPerPageTrackerValue = null

const getCardsPerPage = windowWidth => {
  if (windowWidth >= 1160) {
    return 4
  }

  if (windowWidth > 893) {
    return 3
  }

  return 2
}

const useCardsPerPage = () => {
  const [cardsPerPage, setCardsPerPage] = useState(getCardsPerPage(window.innerWidth)),
    handleWindowResize = () => {
      const updatedCardsPerPage = getCardsPerPage(window.innerWidth)
      if (cardsPerPageTrackerValue !== updatedCardsPerPage) {
        cardsPerPageTrackerValue = updatedCardsPerPage
        setCardsPerPage(updatedCardsPerPage)
      }
    }

  useEffect(() => {
    const windowResizeListener = window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', windowResizeListener)
  }, [])

  return cardsPerPage
}

export default useCardsPerPage
